// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1kthW","list":"styles_list__2P_Rq"};